import React, { useState } from "react";
import Alert from "@mui/material/Alert";
import { Box } from "@mui/material";
import Typography from "@mui/material/Typography";
import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";

// estilos
import { styled } from "@mui/material/styles";

// icons
import TimelineIcon from "@mui/icons-material/Timeline";
import GroupIcon from "@mui/icons-material/Group";
import AddToPhotosIcon from "@mui/icons-material/AddToPhotos";
import AttachFileIcon from "@mui/icons-material/AttachFile";

// importados
import Iniciadores from "./DatosIniciadores";
import Adjuntos from "./DatosAdjuntos";
import Movimientos from "./DatosMovimientos";
import Agregados from "./DatosAgregados";

// declaración de componentes
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-force-tabpanel-${index}`}
      aria-labelledby={`scrollable-force-tab-${index}`}
      {...other}

    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
};

function a11yProps(index) {
  return {
    id: `scrollable-force-tab-${index}`,
    "aria-controls": `scrollable-force-tabpanel-${index}`,
  };
};

const Div = styled("div")(({ theme }) => ({
  marginBottom: 15,
}));

const Div2 = styled("div")(({ theme }) => ({
  flexGrow: 1,
  width: "100%",
  backgroundColor: theme.palette.background.paper,
}));

const Alerta = styled(Alert)(({ theme }) => ({
  width: "100%",
  "& > * + *": {
    marginTop: theme.spacing(2),
    marginBottom: 15,
    color: "#799f4f",
  },
}));

const TabsMenu = (props) => {
  // set de estados
  const { actualizarDatos,...other } = props;
  const [value, setValue] = useState(2);
  const situacion = Array.isArray(props.situacion) ? props.situacion : [];

  //funciones
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  
  return (
    <>
      {props.existe ? (
        <Div>
          <Div2>
            <AppBar position="static" color="default">
              <Tabs
                sx={{ display: { xs: "", sm: "none" } }}
                value={value}
                onChange={handleChange}
                variant="scrollable"
                scrollButtons="on"
                indicatorColor="primary"
                aria-label="scrollable force tabs example"
              >
                {props.involucrados ? (
                  <Tab
                    sx={{ alignSelf: "center", color: "#799F4F" }}
                    icon={<GroupIcon />}
                    {...a11yProps(0)}
                  />
                ) : (
                    <Tab
                      sx={{ alignSelf: "center", color: "rgba(0, 0, 0, 0.38)" }}
                      disabled
                      icon={<GroupIcon />}
                    />
                  )}

                {props.permiso_adjuntos === "S" ? (
                  <Tab
                    sx={{ alignSelf: "center", color: "#799F4F" }}
                    icon={<AttachFileIcon />}
                    {...a11yProps(1)}
                  />
                ) : (
                    <Tab
                      sx={{ alignSelf: "center", color: "rgba(0, 0, 0, 0.38)" }}
                      disabled
                      icon={<AttachFileIcon />}
                    />
                  )}
                <Tab
                  sx={{ alignSelf: "center", color: "#799F4F" }}
                  icon={<TimelineIcon />}
                  {...a11yProps(2)}
                />
                
                    <Tab
                      sx={{ alignSelf: "center", color: "#799F4F" }}
                      icon={<AddToPhotosIcon />}
                      {...a11yProps(3)}
                    />
              </Tabs>

              <Tabs
                sx={{
                  alignSelf: "center",
                  display: { xs: "none", sm: "inline" },
                }}
                value={value}
                onChange={handleChange}
                variant="scrollable"
                scrollButtons="on"
                indicatorColor="primary"
                aria-label="scrollable force tabs example"

              >
                {props.involucrados ? (
                  <Tab
                    sx={{ alignSelf: "center", color: "#799F4F" }}
                    label={"Iniciadores (" + props.involucrados_datos.length + ")"}
                    icon={<GroupIcon />}
                    {...a11yProps(0)}
                  />
                ) : (
                    <Tab
                      sx={{ alignSelf: "center", color: "rgba(0, 0, 0, 0.38)" }}
                      disabled
                      label="Iniciadores"
                      icon={<GroupIcon />}
                    />
                  )}

                {props.permiso_adjuntos === "S" ? (
                  <Tab
                    sx={{ alignSelf: "center", color: "#799F4F" }}
                    label={"Adjuntos"}
                    icon={<AttachFileIcon />}
                    {...a11yProps(1)}
                  />
                ) : (
                    <Tab
                      sx={{ alignSelf: "center", color: "rgba(0, 0, 0, 0.38)" }}
                      disabled
                      label="Adjuntos"
                      icon={<AttachFileIcon />}
                    />
                  )}
                <Tab
                  sx={{ alignSelf: "center", color: "#799F4F" }}
                  label="Movimientos"
                  icon={<TimelineIcon />}
                  {...a11yProps(2)}
                />
                <Tab
                  sx={{ alignSelf: "center", color: "#799F4F" }}
                  label={"Agregados"}
                  icon={<AddToPhotosIcon />}
                  {...a11yProps(3)}
                />
              </Tabs>
            </AppBar>
            <TabPanel value={value} index={0}>
              <Iniciadores
                iniciadores={props.involucrados_datos}
                tramiteId={props.tramite}
                funcion={props.funcion}
                actualizarDatos={actualizarDatos}
                iniciador_id={props.iniciador_id}
              />
            </TabPanel>

            <TabPanel value={value} index={1}>
              <Adjuntos id={props.tramite} funcion={props.funcion} soporte={props.soporte} expediente={props.datos_tramite[0]}></Adjuntos>
            </TabPanel>
            <TabPanel value={value} index={2}>
              <Movimientos
                id={props.tramite}
                mostrar="total"
                folios={props.cant_folios}
                soporte={props.soporte}
                pathruta={props.pathruta}
                actualizarDatos={props.actualizarDatos}
                funcion={props.funcion}
                numero={props.numero}
              ></Movimientos>
            </TabPanel>
           
            <TabPanel value={value} index={3}>
                <Agregados
                  funcion={props.funcion}
                  soporte={props.soporte}
                  id={props.tramite}
                  tipo={props.tramite_expediente}
                  situacion={situacion}
                  numero={
                    props.datos_tramite[0].nro_expediente !== "" &&
                      props.datos_tramite[0].nro_expediente !== null
                      ? props.datos_tramite[0].nro_expediente
                      : props.datos_tramite[0].nro_tramite
                  }
                  actualizarDatos={props.actualizarDatos}
                  soporte={props.soporte}
                ></Agregados> 
            </TabPanel>
          </Div2>
        </Div>
      ) : null}
    </>
  );
};

export default TabsMenu;